<template>
  <v-card class="vms-surface" elevation="0">
    <v-toolbar flat class="px-4 pt-4 pb-2">

      <v-toolbar-title class="vms-page-title">
        <span>Organizations</span>

      </v-toolbar-title>

      <v-spacer></v-spacer>

    </v-toolbar>

    <VmsResponsiveList :items="organizationWithIndex" loading-text="Loading organizations…">
      <template #table>
        <v-data-table :headers="headers" :items="organizationWithIndex" class="elevation-0"></v-data-table>
      </template>

      <template #card="{ item }">
        <div class="vms-list-card__title">{{ item.legal_name }}</div>
      </template>

      <template #empty>
        <div class="vms-empty">
          <v-icon large color="grey lighten-1">mdi-home-city</v-icon>
          <p class="mt-2 grey--text px-4">No Organizations</p>
        </div>
      </template>
    </VmsResponsiveList>
  </v-card>
</template>

<script>
import FacilitiesService from '../../services/facilities.service'
import VmsResponsiveList from '../../components/VmsResponsiveList.vue';
export default {

  name: "FacilityOrganizations",
  components: { VmsResponsiveList },
  props: [
    'facility'
  ],

  data() {
    return {
      organizations: [],
      headers: [
        {
          text: "#",
          align: "start",
          filterable: true,
          value: "index",
        }, 
        {
          text: "Organization",
          align: "start",
          filterable: true,
          value: "legal_name",
        },
      ]
    }
  },

  created() {
    this.$nextTick(() => {
      this.loadOrganizations()
    })
  },

  computed: {
    organizationWithIndex() {
      return this.organizations.map(
        (organizations, index) => ({
          ...organizations,
          index: index + 1
        })
      )
    }
  },

  methods: {

    backToFacilityList() {
      this.$emit('goToFacilityList', 'Come Back');
    },

    loadOrganizations() {
      FacilitiesService.facilityOrganizations(this.facility).then(
        success => {

          this.organizations = success.data.data

        },
        error => {

          console.log(error)

        }
      );
    }
  }
}
</script>